'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIONS = exports.notSessionActions = exports.LOGOUT_SUCCESS = exports.LOGOUT = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return (0, _extends5.default)({}, initialState, {
        loaded: state.loaded
      });
    case LOAD:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        user: (0, _get3.default)(action, 'result.data.user')
      });
    case LOAD_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        error: action.error
      });
    case LOGIN:
      return (0, _extends5.default)({}, state, {
        loggingIn: true
      });
    case LOGIN_SUCCESS:
      {
        return (0, _extends5.default)({}, state, {
          loggingIn: false,
          loaded: true,
          user: (0, _get3.default)(action, 'result.data.user')
        });
      }
    case LOGIN_FAIL:
      return (0, _extends5.default)({}, state, {
        loggingIn: false,
        loaded: false,
        user: null,
        loginError: action.error
      });
    case LOGOUT:
      return (0, _extends5.default)({}, state, {
        loggingOut: true,
        user: null
      });
    case LOGOUT_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loggingOut: false,
        user: null,
        loaded: true
      });
    case LOGOUT_FAIL:
      return (0, _extends5.default)({}, state, {
        loggingOut: false,
        user: null,
        logoutError: action.error
      });
    case ACCEPT_TERMS:
      return (0, _extends5.default)({}, state, {
        termsAccepted: action.termsAccepted
      });
    case SET_REDIRECT:
      return (0, _extends5.default)({}, state, {
        redirect: action.redirect
      });
    case SET_LOGIN_DATA:
      return (0, _extends5.default)({}, state, {
        loginData: action.loginData
      });
    case REMOVE_LOGIN_DATA:
      return (0, _extends5.default)({}, state, {
        loginData: {}
      });
    case SET_LOGIN_FORM_STATE:
      return (0, _extends5.default)({}, state, {
        loginFormState: action.loginFormState
      });
    case UPDATE_BOX_TOKEN:
    case constants.SET_BOX_TOKEN_SUCCESS:
      return (0, _extends5.default)({}, reducer(state, action), {
        user: (0, _extends5.default)({}, state.user, (0, _defineProperty3.default)({}, action.service + 'Token', action.token))
      });
    case constants.DELETE_BOX_TOKEN_SUCCESS:
      return (0, _extends5.default)({}, reducer(state, action), {
        user: (0, _extends5.default)({}, state.user, (0, _defineProperty3.default)({}, action.service + 'Token', undefined))
      });
    case _account.ACTIONS.UPDATE_ACCOUNT_SUCCESS:
      {
        return (0, _qim.update)(['user', ['name', (0, _qim.$set)((0, _get3.default)(action, 'result.data.firstName', state.user.name))], ['surname', (0, _qim.$set)((0, _get3.default)(action, 'result.data.lastName', state.user.surname))]], reducer(state, action));
      }
    default:
      return reducer(state, action);
  }
};

exports.isLoaded = isLoaded;
exports.isAuthed = isAuthed;
exports.load = load;
exports.login = login;
exports.logout = logout;
exports.contact = contact;
exports.resetPassword = resetPassword;
exports.activateAccount = activateAccount;
exports.changePassword = changePassword;
exports.setNewPassword = setNewPassword;
exports.acceptTerms = acceptTerms;
exports.setRedirect = setRedirect;
exports.setLoginData = setLoginData;
exports.removeLoginData = removeLoginData;
exports.register = register;
exports.setBoxToken = setBoxToken;
exports.deleteBoxToken = deleteBoxToken;
exports.updateBoxToken = updateBoxToken;
exports.setLoginFormState = setLoginFormState;
exports.reset = reset;
exports.isLoggedIn = isLoggedIn;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _account = require('./account');

var _qim = require('qim');

var _auth = require('helpers/auth');

var _responseCodes = require('helpers/responseCodes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'auth/LOAD'; /* Auth redux reducer and action creators */

var LOAD_SUCCESS = 'auth/LOAD_SUCCESS';
var LOAD_FAIL = 'auth/LOAD_FAIL';
var LOGIN = 'auth/LOGIN';
var LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'auth/LOGIN_FAIL';
var LOGOUT = exports.LOGOUT = 'auth/LOGOUT';
var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'auth/LOGOUT_FAIL';
var SET_REDIRECT = 'auth/SET_REDIRECT';
var SET_LOGIN_DATA = 'auth/SET_LOGIN_DATA';
var REMOVE_LOGIN_DATA = 'auth/REMOVE_LOGIN_DATA';
var UPDATE_BOX_TOKEN = 'auth/UPDATE_BOX_TOKEN';
var SET_LOGIN_FORM_STATE = 'auth/SET_LOGIN_FORM_STATE';
var ACCEPT_TERMS = 'auth/ACCEPT_TERMS';

var loadReducer = (0, _loadReducer2.default)('auth', {
  contact: {},
  resetPassword: {},
  activateAccount: {},
  changePassword: {},
  setNewPassword: {},
  register: {},
  setBoxToken: {},
  deleteBoxToken: {},
  loginFormState: _auth.loginFormStates.login
});

var constants = loadReducer.constants,
    constantsByKey = loadReducer.constantsByKey,
    reducer = loadReducer.reducer;
var notSessionActions = exports.notSessionActions = [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL];

var ACTIONS = exports.ACTIONS = constants;

var initialState = (0, _extends5.default)({}, loadReducer.initialState, {
  loaded: false,
  user: null,
  loginData: {},
  termsAccepted: false
});

function isLoaded(globalState) {
  return (0, _get3.default)(globalState, 'auth.loaded', false);
}

function isAuthed(globalState) {
  return !!(0, _get3.default)(globalState, 'auth.user');
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post('/project_wa/getAccount', { hideErrorCodes: [1] });
    }
  };
}

function login(email, password) {
  var data = { userEmail: email, userPassword: password };
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/auth/login', { data: data, successCodes: [_responseCodes.loginCodes.reset, _responseCodes.loginCodes.unlock] });
    }
  };
}

function logout() {
  var hideErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(client) {
      return client.post('/auth/logout');
    },
    hideErrors: hideErrors
  };
}

function contact(data) {
  return {
    types: constantsByKey.contact,
    promise: function promise(client) {
      return client.post('auth/contact', { data: data });
    }
  };
}

function resetPassword(data) {
  return (0, _extends5.default)({
    types: constantsByKey.resetPassword,
    promise: function promise(client) {
      return client.post('auth/resetPassword', { data: data });
    }
  }, data);
}

function activateAccount(data) {
  return (0, _extends5.default)({
    types: constantsByKey.activateAccount,
    promise: function promise(client) {
      return client.post('auth/resetPasswordNewUser', { data: data });
    }
  }, data);
}

function changePassword(data) {
  return (0, _extends5.default)({
    types: constantsByKey.changePassword,
    promise: function promise(client) {
      return client.post('auth/changePassword', { data: data });
    }
  }, data);
}

function setNewPassword(code, key, data) {
  var isNew = data.isNew,
      postData = (0, _objectWithoutProperties3.default)(data, ['isNew']);

  return (0, _extends5.default)({
    types: constantsByKey.setNewPassword,
    promise: function promise(client) {
      return client.post('auth/setNewPassword/' + key + '/' + code + (isNew && '?new=1'), { data: (0, _extends5.default)({ code: code, key: key }, postData) });
    },
    code: code,
    key: key
  }, data);
}

function acceptTerms(termsAccepted) {
  return {
    type: ACCEPT_TERMS,
    termsAccepted: termsAccepted
  };
}

function setRedirect(redirect) {
  return {
    type: SET_REDIRECT,
    redirect: redirect
  };
}

function setLoginData(loginData) {
  return {
    type: SET_LOGIN_DATA,
    loginData: loginData
  };
}

function removeLoginData() {
  return {
    type: REMOVE_LOGIN_DATA
  };
}

function register(data) {
  return (0, _extends5.default)({
    types: constantsByKey.register,
    promise: function promise(client) {
      return client.post('auth/register', { data: data });
    }
  }, data);
}

function setBoxToken(service, token) {
  return {
    types: constantsByKey.setBoxToken,
    promise: function promise(client) {
      return client.post('project_wa/setBoxToken', { data: { type: service, token: token } });
    },
    service: service,
    token: token
  };
}

function deleteBoxToken(service) {
  return {
    types: constantsByKey.deleteBoxToken,
    promise: function promise(client) {
      return client.post('project_wa/deleteBoxToken', { data: { type: service } });
    },
    service: service
  };
}

function updateBoxToken(service, token) {
  return {
    type: UPDATE_BOX_TOKEN,
    service: service,
    token: token
  };
}

function setLoginFormState(loginFormState) {
  return {
    type: SET_LOGIN_FORM_STATE,
    loginFormState: loginFormState
  };
}

function reset() {
  return {
    type: 'RESET'
  };
}

function isLoggedIn() {
  return function (dispatch, getState) {
    var user = getState().auth.user;
    return !!user;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 31
// module chunks = 1